// Estados de carregamento e erro padronizados. O esqueleto ocupa o mesmo espaço do conteúdo
// final para a página não "pular" quando o dado chega (CLS ≈ 0).
import { ApiError } from "@/api/client";

export function Skeleton({ height = 120, count = 1 }: { height?: number; count?: number }) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="card skeleton" style={{ height, marginBottom: 18 }} aria-hidden="true" />
      ))}
    </>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const forbidden = error instanceof ApiError && error.isForbidden;
  return (
    <div className="card empty" role="alert">
      <h2>{forbidden ? "Este recorte não está no seu acesso" : "Não foi possível carregar os dados"}</h2>
      <p className="muted">
        {forbidden ? "Escolha outra organização ou unidade no topo." : "Tente novamente em alguns segundos."}
      </p>
      {onRetry && !forbidden && <button onClick={onRetry}>Tentar novamente</button>}
    </div>
  );
}

/** Aviso de que o card ainda é servido pelo mock (some quando a rota sai do manifest). */
export function MockBadge({ route }: { route: string }) {
  if (import.meta.env.VITE_MOCKS !== "on") return null;
  return (
    <span className="mock-badge" title={`Rota ainda mockada: ${route}`}>
      dados demonstrativos
    </span>
  );
}
